<template>
  <div class="flex items-center pl-2 ml-2 border rounded-lg basis-1/2">
    <i class="pi pi-search text-foundationGrey900" />

    <input
      class="ml-2 outline-none outline placeholder:text-sm w-[90%]"
      :placeholder="placeholder"
      @input="handleQuery"
      :value="queryValue"
      type="text"
    />
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: ["handleQuery", "queryValue", "placeholder"],
};
</script>

<style>
</style>